export * from './common';
export * from './filters';
export * from './hotel';
export * from './country-code';
export * from './booking';
export * from './states';
export * from './condo';
export * from './concierge';
export * from './resources';
export * from './image-details';
export * from './pages';
export * from './columns';
export * from './cars';

export const MEMBER_STATUS = {
    ALL: 'all',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    ACTIVESTATE: 'Active'
}

export const BOOKING_STATUS = {
    CONFIRMED: 'Confirmed',
    CANCELLED: 'Cancelled',
    ERROR: 'Error',
    UNCONFIRMED: 'Unconfirmed'

}

export const QUERY_PARAMS = {
    LOCATION: 'location',
    ROOMS: 'rooms',
    DATE: 'dates',
    SESSION_KEY: "sessionKey"

}

export const EXPORT_KEYS = {
    TOP_DESTINATIONS: 'TopDestinations',
    TOP_MEMBERS: 'TopMembers',
    TOTAL_SUMMARY: 'TotalSummary',
};

export const EXPORT_LABELS = {
    TOP_DESTINATIONS: 'Top Destinations',
    TOP_MEMBERS: 'Top Members',
    TOTAL_SUMMARY: 'Total Summary',
};
export enum EXPORT_TYPE {
    EXCEL = 'excel',
    CSV = 'csv',
}
export const FILE_TYPE = {
    EXCEL: 'xlsx',
    CSV: 'csv'
}

export const FileType = 'file'
